import { FIELD_VALIDATION_RULES } from "../consts/validationRule";
import { changeInput } from "../../utils/helpers/validateFields.js";

const handleChangePhoneNumber = (setUserPhoneNumberErrorText, setUserPhoneNumber) => event => {
  const value = event.target.value.replace(/\D+/g, "");

  const options = [
    {
      type: FIELD_VALIDATION_RULES.EMPTY_LENGTH,
      targets: [value],
      refs: [event.target],
      error: "Поле не может быть пустым",
      setter: setUserPhoneNumberErrorText,
    },
  ];

  changeInput(value, setUserPhoneNumber, options);
};

export default handleChangePhoneNumber;
